<ng-select
  #ngSelectComponent
  [ngClass]="ngClass"
  [items]="items"
  [multiple]="true"
  [closeOnSelect]="false"
  [loading]="loading"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [appendTo]="appendTo"
  [virtualScroll]="virtualScroll"
  [typeahead]="typeahead"
  [minTermLength]="minTermLength"
  [groupBy]="groupBy"
  [compareWith]="compareWith"
  [groupValue]="groupValue"
  [selectableGroup]="selectableGroup"
  [selectableGroupAsModel]="selectableGroupAsModel"
  (search)="search.emit($event)"
  (scroll)="scroll.emit($event)"
  (scrollToEnd)="scrollToEnd.emit()"
  [(ngModel)]="innerValue"
>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div *ngFor="let item of items | slice : 0 : 3" class="ng-value">
            <ng-template [ngIf]="!selectedOptionTemplate" [ngIfElse]="selectedOptionTemplateTmp">
                <span class="ng-value-label">{{ item[bindLabel] }}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </ng-template>
            <ng-template #selectedOptionTemplateTmp
                    [ngTemplateOutlet]="selectedOptionTemplate"
                    [ngTemplateOutletContext]="{item: item, clear: clear}"
            ></ng-template>
        </div>
        <div *ngIf="items.length > 3" class="ng-value">
            <span class="ng-value-label">{{ items.length - 3 }} more...</span>
        </div>
    </ng-template>
    <ng-template ng-header-tmp>
        <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap">
            <div class="d-flex align-items-center gap-3">
                <span *ngIf="!hideSelectAll"
                      class="text-capitalize link-primary cursor-pointer text-decoration-underline-hover"
                      (click)="toggle(true)">select all</span>
                <ng-container *ngIf="headerExtra" [ngTemplateOutlet]="headerExtra"></ng-container>
                <span class="text-capitalize link-primary cursor-pointer text-decoration-underline-hover"
                      (click)="toggle(false)">clear selection</span>
            </div>
            <span class="text-capitalize link-primary cursor-pointer text-decoration-underline-hover"
                  (click)="closeDropdown(ngSelectComponent)">close selector</span>
        </div>
    </ng-template>
    <ng-container *ngIf="footerExtra">
        <ng-template ng-footer-tmp>
            <ng-container [ngTemplateOutlet]="footerExtra"></ng-container>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="optionTemplate">
        <ng-template ng-option-tmp let-item="item">
            <ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{item: item}"></ng-template>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="groupBy">
        <ng-template ng-optgroup-tmp let-item="item">
            <ng-template
                    [ngIf]="groupByTemplate"
                    [ngIfElse]="defaultGroupByTemplate"
                    [ngTemplateOutlet]="groupByTemplate"
                    [ngTemplateOutletContext]="{item: item}"
            ></ng-template>
            <ng-template #defaultGroupByTemplate>
                {{item[groupBy] || 'Without Group'|translate}}
            </ng-template>
        </ng-template>
    </ng-container>
</ng-select>
